import baseStyles from './base'
import inkStyles from './ink'
import oliveStyles from './olive'

export default {
  base: baseStyles,
  ink: inkStyles,
  olive: oliveStyles,
}
